import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, FileText } from "lucide-react";
import { track } from "../../lib/track";

export const PHONE_DISPLAY = "281-901-9914";
export const PHONE_HREF = "tel:+12819019914";
export const EMAIL = "info@pgpsusa.com";

export function MobileActionBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/portal")) return null;
  return (
    <>
      <div className="h-[64px] md:hidden" aria-hidden="true" />
      <nav data-testid="mobile-action-bar" aria-label="Quick contact"
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-4px_24px_-12px_rgba(11,31,58,.35)]">
        <div className="grid grid-cols-3 divide-x divide-slate-200">
          <a href={PHONE_HREF} data-testid="mobile-bar-call" onClick={() => track("phone_click", { source: "mobile_bar" })}
            className="flex flex-col items-center justify-center gap-1 py-3 text-[var(--pg-navy)] active:bg-slate-50">
            <Phone size={18} /><span className="text-[11.5px] font-[Poppins] font-semibold">Call</span>
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="mobile-bar-email" onClick={() => track("email_click", { source: "mobile_bar" })}
            className="flex flex-col items-center justify-center gap-1 py-3 text-[var(--pg-navy)] active:bg-slate-50">
            <Mail size={18} /><span className="text-[11.5px] font-[Poppins] font-semibold">Email</span>
          </a>
          <Link to="/request-a-quote" data-testid="mobile-bar-rfq" onClick={() => track("submit_rfq_clicked", { source: "mobile_bar" })}
            className="flex flex-col items-center justify-center gap-1 py-3 bg-[var(--pg-accent)] text-white">
            <FileText size={18} /><span className="text-[11.5px] font-[Poppins] font-semibold">Request Quote</span>
          </Link>
        </div>
      </nav>
    </>
  );
}

export function ContactActions({ source, dark = true, className = "" }) {
  const ghost = dark
    ? "border border-white/35 text-white hover:bg-white hover:text-[var(--pg-navy)]"
    : "border border-slate-300 text-[var(--pg-navy)] hover:border-[var(--pg-accent)] hover:text-[var(--pg-accent)]";
  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid={`contact-actions-${source}`}>
      <Link to="/request-a-quote" data-testid={`${source}-request-quote`} className="btn-primary"
        onClick={() => track("submit_rfq_clicked", { source })}>
        <FileText size={17} /> Request a Quote
      </Link>
      <a href={PHONE_HREF} data-testid={`${source}-call`} onClick={() => track("phone_click", { source })}
        className={`inline-flex items-center gap-2 font-[Poppins] font-semibold px-5 py-3.5 rounded-full transition-colors ${ghost}`}>
        <Phone size={16} /> Call {PHONE_DISPLAY}
      </a>
      <a href={`mailto:${EMAIL}`} data-testid={`${source}-email`} onClick={() => track("email_click", { source })}
        className={`inline-flex items-center gap-2 font-[Poppins] font-semibold px-5 py-3.5 rounded-full transition-colors ${ghost}`}>
        <Mail size={16} /> Email Us
      </a>
    </div>
  );
}
